var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / star filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M11.9086 3.68294C12.1043 3.36828 12.5622 3.36828 12.7579 3.68294L15.2412 7.67708C15.3101 7.78779 15.4194 7.86723 15.546 7.89849L20.112 9.02605C20.4717 9.11488 20.6133 9.55042 20.3745 9.83372L17.3432 13.4298C17.2592 13.5295 17.2174 13.658 17.2268 13.788L17.5654 18.4791C17.5921 18.8486 17.2216 19.1178 16.8784 18.9782L12.5216 17.2066C12.4008 17.1575 12.2657 17.1575 12.1449 17.2066L7.78813 18.9782C7.4449 19.1178 7.07441 18.8486 7.10108 18.4791L7.43969 13.788C7.44908 13.658 7.40731 13.5295 7.32329 13.4298L4.29204 9.83372C4.05324 9.55042 4.19476 9.11488 4.55447 9.02605L9.12052 7.89849C9.24708 7.86723 9.35644 7.78779 9.42527 7.67708L11.9086 3.68294Z",
    fill: "url(#paint0_linear_2563_1865)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2563_1865",
    x1: 12.3333,
    y1: 3,
    x2: 12.3333,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#605DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A26D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilled);
export default __webpack_public_path__ + "static/media/filled.0fe347c3bcfb32b6b292d48efe838f2e.svg";
export { ForwardRef as ReactComponent };